module.exports = __webpack_public_path__ + "fonts/DaxWebPro-Medi.ea94ba77.woff";